import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorIcon from '@mui/icons-material/Error';
import Loading from 'components/Loading';
import { useTranslation } from 'react-i18next';
import { green, red } from '@mui/material/colors';
import { StyTitle } from './styles';

type Props = {
    title: string;
    header: string;
    isLoading: boolean;
    isError?: boolean;
    children: React.ReactNode;
    footer?: string;
};

const StyCheckedIcon = styled(CheckCircleRoundedIcon, {
    name: 'StyCheckedIcon',
})(() => ({
    fontWeight: 700,
    color: green[600],
}));

const StyErrorIcon = styled(ErrorIcon, {
    name: 'StyCheckedIcon',
})(() => ({
    fontWeight: 700,
    color: red[600],
}));

const SummaryModal = ({
    title,
    header,
    footer,
    isError,
    children,
    isLoading,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    if (isLoading)
        return (
            <>
                <StyTitle
                    sx={{ alignItems: 'center', display: 'flex' }}
                    variant="h4"
                >
                    {title}
                </StyTitle>
                <Loading />
            </>
        );

    return (
        <>
            <StyTitle
                sx={{ display: 'flex', alignItems: 'center' }}
                variant="h4"
            >
                {title}
                <Box sx={{ pl: '10px' }}>
                    {isError ? <StyErrorIcon /> : <StyCheckedIcon />}
                </Box>
            </StyTitle>
            <Typography>{header}</Typography>
            <Container sx={{ pl: '10x', pt: '10px' }}>{children}</Container>
            {footer && (
                <>
                    <Typography
                        variant="body1Bold"
                        sx={{ whiteSpace: 'normal', pt: '10px' }}
                    >
                        {t('adminBudgetSpace.summary.error')}
                    </Typography>
                    <Typography
                        variant="body1Bold"
                        sx={{ whiteSpace: 'pre-line' }}
                    >
                        {footer}
                    </Typography>
                </>
            )}
        </>
    );
};

export default SummaryModal;
